"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMediaGallery = void 0;
const swiper_1 = __importDefault(require("./swiper/swiper"));
const modal_dialog_1 = require("./modal-dialog");
const utils_1 = require("./utils");
/**
 * Media gallery is a grid of interactive images that can be viewed in native dialog.
 * Opened dialog contains a slider that allows user to change active slide.
 * Slides can display any kind of content, but currently only images are supported.
 *
 * @param {HTMLElement} container Media gallery container. Must contain dialog and slider elements.
 */
async function initMediaGallery(container) {
    const sliderEl = container.querySelector('[data-media-gallery-slider]');
    const dialogEl = container.querySelector('dialog');
    if (!dialogEl || !sliderEl) {
        console.warn('Media gallery could not be initialized, slider or dialog is missing.');
        return;
    }
    console.log('init media gallery with modals');
    (0, modal_dialog_1.useNativeDialogAsModal)(dialogEl);
    const bullets = container.querySelectorAll('.swiper-pagination-bullet');
    const thumbnails = Array.from(bullets).reduce((value, item) => {
        value[parseInt(item.dataset.index)] = item.dataset.thumbnail;
        return value;
    }, {});
    const paginationSeparator = container.dataset.paginationSeparator;
    const swiperIndex = container.dataset.swiperIndex;
    // Swiper hidden slides are focusable which breaks the slider
    // https://github.com/nolimits4web/swiper/issues/4006
    //
    // Set all but visible slide to inert to avoid slider breakdown
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/inert
    const setHiddenSlidesInert = () => {
        const slides = dialogEl.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
            slide.inert = !slide.classList.contains('swiper-slide-active');
        });
    };
    const sliderConfig = {
        navigation: {
            nextEl: '.js-swiper-next',
            prevEl: '.js-swiper-prev',
        },
        autoHeight: true,
        centeredSlides: true,
        slidesPerView: 1,
        effect: 'fade',
        speed: 300,
        crossFade: true,
        pagination: paginationSeparator ? {
            el: `.js-swiper-pagination--${swiperIndex}`,
            type: 'custom',
            renderCustom: function (_, current, total) {
                return current + paginationSeparator + total;
            }
        } : {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: function (index, className) {
                return `<button type="button" class="${className}"><img src="${thumbnails[index + 1]}" alt="" /></button>`;
            }
        },
        //loop: true,
        on: {
            update() {
                setTimeout(setHiddenSlidesInert, 0);
            },
            slideChange() {
                setTimeout(setHiddenSlidesInert, 0);
            },
        },
    };
    // Set mobile to use page numbers instead of image previews
    const isMobile = ['xs', 'sm'].includes((0, utils_1.getBreakpoint)());
    if (isMobile && !paginationSeparator) {
        sliderConfig.pagination = {
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
                return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`;
            }
        };
    }
    const slider = new swiper_1.default(sliderEl, sliderConfig);
    const onKeyPressClick = (e) => {
        if (e.key === 'Enter') {
            toggleButtonHandler(e);
        }
    };
    // Handler for gallery buttons that open selected media item in modal
    const toggleButtonHandler = (e) => {
        const button = e.target.closest('button') || e.target.closest('[role="button"]');
        const index = parseInt(button.dataset.mediaGalleryToggle) || 0;
        dialogEl.showModal();
        slider.update();
        slider.slideTo(index);
    };
    const toggleButtons = container.querySelectorAll('[data-media-gallery-toggle]');
    toggleButtons.forEach(button => {
        button.addEventListener('click', toggleButtonHandler);
        button.addEventListener('keyup', onKeyPressClick);
    });
}
exports.initMediaGallery = initMediaGallery;
exports.default = initMediaGallery;
